import React, { createContext } from "react";
const HostVideoContext = createContext();
export default HostVideoContext;
